const favoritesStorageKey = 'omnibarFavorites';

export function getFavoriteIds(): string[] {
  try {
    const stored = JSON.parse(localStorage.getItem(favoritesStorageKey) || '[]');
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
}

export function toggleFavorite(id: string): string[] {
  const favoriteIds = getFavoriteIds();
  const updated = favoriteIds.includes(id) ? favoriteIds.filter(favoriteId => favoriteId !== id) : [...favoriteIds, id];
  localStorage.setItem(favoritesStorageKey, JSON.stringify(updated));
  return updated;
}
